import React, { useEffect, useState } from "react";
import { styleSearch } from "./styles";
import { useForm, Controller } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { defaultSearchValues, typeState } from "./models";
import { useStateValue } from "../../context/store";
import TitleCase from "react-title-case";
import { getActiveRegionals } from "../../actions/regional-actions";
import {
  Button,
  FormControl,
  Select,
  Grid,
  InputLabel,
  TextField,
  MenuItem,
  FormHelperText,
} from "@material-ui/core";
import { REQUIRED_MESSAGE } from "../../constants";

const SearchLaboratory = (props) => {
  const [stateLaboratory, setStateLaboratory] = useState(false);
  const schema = yup.object().shape({
    laboratoryName: stateLaboratory
      ? null
      : yup
          .string()
          .nullable()
          .notRequired(REQUIRED_MESSAGE)
          .min(3, "Ingrese mínimo 3 caracteres")
          .max(100, "Ingrese máximo 100 caracteres"),
    regionalId: yup.string().nullable().notRequired(),
    status: yup.string().nullable().notRequired(),
  });

  const { register, handleSubmit, control, errors, setValue, watch } = useForm({
    resolver: yupResolver(schema),
    defaultSearchValues,
    mode: "onChange",
    reValidateMode: "onChange",
  });

  const [dateError, setDateError] = useState(false);
  const [dateErrorMessage, setDateErrorMessage] = useState("");
  const [regionales, setRegionales] = useState([]);
  const _ = require("lodash");
  const [{}, dispatch] = useStateValue();

  const clearForm = () => {
    setValue("laboratoryName", null);
    setValue("regionalId", null);
    setValue("status", null);
    setDateError(false);
    setDateErrorMessage("");
  };

  useEffect(() => {
    const getRegionales = async () => {
      const response = await getActiveRegionals();
      let orderRegionales = _.sortBy(
        response.data && response.data.regionalList,
        (o) => o.name
      );
      setRegionales(orderRegionales);
    };
    getRegionales();
  }, []);

  const onSubmit = (data) => {
    if (
      data.laboratoryName !== null ||
      data.regionalId !== null ||
      data.status !== null
    ) {
      dispatch({
        type: "SET_FILTER_LABORATORY",
        filter: data,
        isFilter: true,
      });
    }
  };

  const clearBtn = () => {
    clearForm();
    dispatch({
      type: "SET_FILTER_LABORATORY",
      filter: {
        laboratoryName: null,
        regionalId: null,
        status: null,
      },
      isFilter: true,
    });
  };

  const seeNameLaboratory = watch("laboratoryName");
  useEffect(() => {
    if (seeNameLaboratory === "") {
      setStateLaboratory(true);
    } else {
      setStateLaboratory(false);
    }
  }, [seeNameLaboratory]);

  const classes = styleSearch();
  return (
    <form
      className={classes.form}
      onSubmit={handleSubmit(onSubmit)}
      autoComplete="off"
    >
      <Grid container spacing={1} style={{ paddingTop: "50px" }}>
        <Grid item xs={12} md={3} lg={3}>
          <FormControl fullWidth>
            <TextField
              className={classes.whiteBackGround}
              fullWidth
              defaultValue=""
              inputRef={register}
              variant="outlined"
              type="text"
              autoComplete="off"
              error={
                stateLaboratory
                  ? null
                  : !!errors.hasOwnProperty("laboratoryName") &&
                    errors["laboratoryName"].message
              }
              helperText={
                stateLaboratory
                  ? null
                  : errors.hasOwnProperty("laboratoryName") &&
                    errors["laboratoryName"].message
              }
              label="Nombre del laboratorio"
              name="laboratoryName"
              size="small"
            />
          </FormControl>
        </Grid>

        <Grid item xs={12} md={2} lg={2}>
          <FormControl
            variant="outlined"
            fullWidth
            size="small"
            error={
              !!errors.hasOwnProperty("regionalId") &&
              errors["regionalId"].message
            }
          >
            <InputLabel
              htmlFor="outlined-select-regionalId"
              shrink={true}
              size="small"
            >
              Regional
            </InputLabel>
            <Controller
              className={classes.whiteBackGround}
              fullWidth
              control={control}
              inputRef={register}
              label="Regional"
              size="small"
              name="regionalId"
              notched={true}
              defaultValue={null}
              inputProps={{
                name: "regionalId",
                id: "outlined-select-regionalId",
              }}
              as={
                <Select>
                  <MenuItem
                    className={classes.menuItem}
                    aria-label="None"
                    value={null}
                  >
                    <em>&nbsp;</em>
                  </MenuItem>
                  {regionales.map((op) => (
                    <MenuItem
                      className={classes.menuItem}
                      key={op.id}
                      value={op.id}
                    >
                      <TitleCase string={op.name} />
                    </MenuItem>
                  ))}
                </Select>
              }
            />
            <FormHelperText>
              {errors.hasOwnProperty("regionalId") &&
                errors["regionalId"].message}
            </FormHelperText>
          </FormControl>
        </Grid>
        <Grid item xs={12} md={2} lg={2}>
          <FormControl
            variant="outlined"
            fullWidth
            size="small"
            error={
              !!errors.hasOwnProperty("status") && errors["status"].message
            }
          >
            <InputLabel
              htmlFor="outlined-select-status"
              shrink={true}
              size="small"
            >
              Estado
            </InputLabel>
            <Controller
              className={classes.whiteBackGround}
              fullWidth
              control={control}
              inputRef={register}
              label="Estado"
              size="small"
              name="status"
              notched={true}
              defaultValue={null}
              inputProps={{
                name: "status",
                id: "outlined-select-status",
              }}
              as={
                <Select>
                  <MenuItem
                    className={classes.menuItem}
                    aria-label="None"
                    value={null}
                  >
                    <em>&nbsp;</em>
                  </MenuItem>
                  {typeState.map((state) => (
                    <MenuItem
                      className={classes.menuItem}
                      key={state}
                      value={state}
                    >
                      <TitleCase string={state} />
                    </MenuItem>
                  ))}
                </Select>
              }
            />
            <FormHelperText>
              {errors.hasOwnProperty("status") && errors["status"].message}
            </FormHelperText>
          </FormControl>
        </Grid>
        <Grid item xs={12} md={3} lg={3} style={{ paddingLeft: "15px" }}>
          <Button
            variant="contained"
            className={classes.buttonSearch}
            type="submit"
          >
            Buscar
          </Button>
          &nbsp;&nbsp;
          <Button
            variant="contained"
            className={classes.buttonSearch}
            type="submit"
            onClick={clearBtn}
          >
            Limpiar
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

export default SearchLaboratory;
